const Service = require('gui/inputs/service');
module.exports = class UniqueService extends Service {
  constructor(opts = {}) {
    super(opts);
  }
};